<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button type="primary" @click="create">新增返工单</el-button>
      </template>
      <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="160">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canWrite()" type="text" @click="edit(row)">编辑</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/reportmanagement/rework/list'



export default {
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
      api: require("@/api/pu/prTestRework").default,
    }
  },
  methods: {
    create(){
      this.toURL({
        name: 'editrework',
        params: {
          type: 'create'
        }
      })
    },
    edit({TestReworkId}){
       this.api.info({TestReworkId}).then(res => {
        if(res.Code === 0){
          this.toURL({
            name: 'editrework',
            params: {
              type: 'edit',
              data: res.Data
            }
          })
        }else{
          this.$message({type: 'warning', message: res.Msg})
        }
       })

       
    },
    toURL(o){
      this.$router.push(o)
    },
  }
  
};
</script>